import React from 'react'
import PropTypes from 'prop-types'

import { Input, ErrorMessage, InputContainer } from './styles'

import colors from '@settings/styleSettings'

const TextInput = ({
  placeholder,
  value,
  onChange,
  type,
  style,
  showPassword,
  maxLength,
  onBlur,
  disabled,
  error,
  inputParams,
  errorMessage,
  onKeyDown
}) => (
  <InputContainer error={error}>
    <Input
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      type={showPassword ? 'text' : type}
      min={type === 'date' ? '2020-01-01' : ''}
      max={type === 'date' ? '2500-01-01' : ''}
      maxLength={maxLength}
      onBlur={onBlur}
      style={style}
      placeholderTextColor={colors.strongGray}
      disabled={disabled}
      mode="outlined"
      error={error}
      {...inputParams}
      onKeyDown={onKeyDown}
    />
    <ErrorMessage error={error}>{errorMessage}</ErrorMessage>
  </InputContainer>
)

TextInput.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.shape({}),
  type: PropTypes.string,
  showPassword: PropTypes.bool,
  maxLength: PropTypes.number,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  inputParams: PropTypes.object,
  errorMessage: PropTypes.string,
  onKeyDown: PropTypes.func
}

TextInput.defaultProps = {
  placeholder: null,
  value: '',
  onChange: null,
  style: null,
  type: null,
  showPassword: false,
  maxLength: null,
  onBlur: null,
  disabled: false,
  error: undefined,
  inputParams: {},
  errorMessage: '',
  onKeyDown: null
}

export default TextInput
